import { useTagsContext } from '../context/TagsContext'
import ClientAPI from '../../../common/ClientAPI'

function useTags() {
  const { tagsConfig, setTagsConfig } = useTagsContext()

  const getEnabledTag = (tags) => {
    let tagsEnabled
    Object.keys(tags).forEach((key) => {
      if (tags[key].enabledTag) {
        tagsEnabled = { ...tagsEnabled, [key]: tags[key] }
      }
    })

    return tagsEnabled
  }
  const handleTags = async () => {
    const api = new ClientAPI()

    try {
      if (Object.keys(tagsConfig).length === 0) {
        const response = await api.getPromotionsConfig()

        const { campaign, attribute } = response

        const campaignsEnabled = getEnabledTag(campaign)
        const attributesEnabled = getEnabledTag(attribute)

        setTagsConfig({
          ...response,
          campaign: campaignsEnabled,
          attribute: attributesEnabled,
        })
      }
    } catch (error) {
      setTagsConfig({})
    }
  }

  return {
    handleTags,
  }
}

export default useTags
